import React, { Component } from 'react';
import {
    Button,
    DialogActions,
    DialogContent,
    Divider,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Dialog,
    DialogTitle
} from "@mui/material";
import { Cart, CartItem, CartItemAddon } from "../../../classes/types/cart/cart";
import { CartHandler } from "../../../classes/methods/cartMethods/cartMethods";
import { AuthHandler } from "../../../classes/methods/authMethods/authMethods";
import { ShippingAddress, User } from "../../../classes/types/user/user";
import { euroPrint } from '../../../classes/types/currencysettings';
import PayOrderBtn from '../../customComponents/payOrderBtn/payOrderBtn';
import { OrderHandler } from '../../../classes/methods/orderMethods/orderMethods';
import PaymentHandler, { PaymentIntent } from '../../../classes/methods/paymentMethods/paymentMethods';
import { EPaymentMethod, Order } from '../../../classes/types/order/order';
import dayjs from "dayjs";
import { EVatRate } from '../../../classes/types/product/product';
import { useNavigate } from "react-router-dom";

// --- Props aggiornate: aggiunto navigate
interface props {
    navigate: ReturnType<typeof useNavigate>;
}

interface state {
    cart: Cart;
    shippingAddresses: Array<ShippingAddress>;
    selectedPaymentMethod: EPaymentMethod;
    selectedShippingAddress: string;
    selectedShippingAddressId: string;
    currentUser: User;
    paymentLoading: boolean;
    productsError: Array<any>;
    errorDialog: boolean;
    shippingDate: dayjs.Dayjs;
    showEditConfiguration: boolean;
    selectedCartItem: CartItem;
    notes: string;
}

class Checkout extends Component<props, state> {

    constructor(props: props) {
        super(props);

        this.state = {
            currentUser: new User(),
            cart: new Cart(),
            shippingAddresses: [],
            selectedPaymentMethod: EPaymentMethod.Other,
            selectedShippingAddress: "Seleziona indirizzo",
            selectedShippingAddressId: "",
            paymentLoading: false,
            productsError: [],
            errorDialog: false,
            shippingDate: dayjs(),
            showEditConfiguration: false,
            selectedCartItem: new CartItem(),
            notes: ""
        };
    }

    componentDidMount() {
        this.refreshData();
    }

    refreshData = () => {
        AuthHandler.isLogged().then((user: any) => {
            if (user === false) {
                this.props.navigate(`/login`);
            } else {
                this.setState({ currentUser: user });
                AuthHandler.getShippingAddresses().then((newShippingAddresses) => {
                    let defaultShippingAddr = "nessuno";
                    newShippingAddresses.every((addr: any) => {
                        if (addr.id === user.defaultShippingAddressId) {
                            defaultShippingAddr = addr.fullAddress;
                            return false;
                        }
                        return true;
                    });
                    this.setState({
                        selectedShippingAddress: defaultShippingAddr,
                        selectedShippingAddressId: user.defaultShippingAddressId,
                        shippingAddresses: newShippingAddresses,
                    });
                }).catch((err) => console.log(err));
            }
        }).catch((err) => {
            console.log(err);
            this.props.navigate(`/login`);
        });

        CartHandler.getCart().then((newCart) => {
            newCart.items.forEach((item) => {
                item.addons.sort((a, b) => a.sequence > b.sequence ? 1 : -1);
            });
            let day = 1;
            let newShippingDate = this.state.shippingDate.add(day, 'day');
            while (newShippingDate.day() === 6 || newShippingDate.day() === 0) {
                day++;
                newShippingDate = this.state.shippingDate.add(day, 'day');
            }
            this.setState({
                cart: newCart,
                shippingDate: newShippingDate,
            });
        }).catch((err) => console.log(err));
    }

    onShippingAddressChange = (e: any) => {
        this.setState({ selectedShippingAddressId: "" });
        this.state.shippingAddresses.every((addr: ShippingAddress) => {
            if (addr.fullAddress === e.target.value) {
                this.setState({ selectedShippingAddressId: addr.id });
                return false;
            }
            return true;
        });
        this.setState({ selectedShippingAddress: e.target.value });
    }

    onPaymentMethodChange = (e: any) => {
        this.setState({
            selectedPaymentMethod: e.target.value === "0" ? EPaymentMethod.CreditCard : EPaymentMethod.Other,
        });
    }

    onNotesChange = (e: any) => {
        this.setState({ notes: e.target.value });
    }

    setShowEditConfigurationProductDialog = (cartItem?: CartItem) => {
        this.setState({
            showEditConfiguration: !this.state.showEditConfiguration,
            selectedCartItem: cartItem ?? new CartItem(),
        });
    }

    calculateProductTotal = (cartItem: CartItem): number => {
        let productTotal = 0;
        if (cartItem.addons.length > 0) {
            cartItem.addons.forEach((addon) => {
                productTotal += addon.selectedOptionPrice * addon.selectedQuantity * cartItem.quantity;
            });
        }
        if (cartItem.product.price !== undefined) {
            productTotal += cartItem.product.taxSIAE !== 0 ? cartItem.product.taxSIAE * cartItem.quantity : 0;
            productTotal += cartItem.product.price * cartItem.quantity;
        }
        return productTotal;
    }

    onPayPressed = () => {
        this.setState({ paymentLoading: true });
        OrderHandler.createOrder(this.state.selectedShippingAddressId, this.state.selectedPaymentMethod, this.state.shippingDate, this.state.notes)
            .then((createdOrder: Order) => {
                if (createdOrder.paymentMethod === 0) {
                    PaymentHandler.getPaymentUrl(createdOrder).then((paymentResponse: PaymentIntent) => {
                        window.location.replace(paymentResponse.paymentUrl);
                    }).catch(console.log);
                } else {
                    window.location.replace("https://b2b.gigabytedistribuzione.it/ordine-ricevuto/" + createdOrder.id);
                }
            })
            .catch((err) => {
                console.log(err.response.data);
                if (Array.isArray(err.response.data)) {
                    this.setState({ productsError: err.response.data });
                }
                this.setState({ paymentLoading: false, errorDialog: true });
            });
    }

    render() {
        return (
            <div style={{ textAlign: "left", paddingBottom: "2%", marginTop: "2%", paddingLeft: "60px", paddingRight: "60px" }}>
                <Typography variant="h3">Conferma ordine</Typography>
                <Grid container>
                    {/* --- Form dati */}
                    <Grid md={6} direction="column" justifyContent="flex-start" container item>
                        <Typography style={{ fontWeight: "bold" }} variant="h5">Dati di fatturazione</Typography>
                        <br />
                        <TextField value={this.state.currentUser.name} InputProps={{ readOnly: true }} style={{ minWidth: "80%" }} variant="outlined" label="Ragione Sociale" />
                        <br />
                        <Typography style={{ fontWeight: "bold" }} variant="h5">Dati di spedizione</Typography>
                        <br />
                        <FormControl required variant="outlined" style={{ minWidth: "80%" }}>
                            <InputLabel htmlFor="age-native-simple">Indirizzo di spedizione</InputLabel>
                            <Select
                                variant={'outlined'}
                                value={this.state.selectedShippingAddress}
                                onChange={this.onShippingAddressChange}
                                label="Indirizzo di spedizione"
                            >
                                <MenuItem value={"nessuno"}>Nessuno</MenuItem>
                                {this.state.shippingAddresses.map((addr, index) =>
                                    <MenuItem key={index} value={addr.fullAddress}>{addr.fullAddress}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <br />
                        <FormControl required variant="outlined">
                            <FormLabel component="legend">Pagamento</FormLabel>
                            <RadioGroup aria-label="Metodo di pagamento" name="pagamento" value={this.state.selectedPaymentMethod} onChange={this.onPaymentMethodChange}>
                                <FormControlLabel value="1" control={<Radio checked={this.state.selectedPaymentMethod === EPaymentMethod.Other} />} label={this.state.currentUser.registeredPaymentMethod} />
                            </RadioGroup>
                        </FormControl>
                        <br />
                        <TextField style={{ marginTop: "2%", width: "90%" }} id="outlined-multiline-static" label="Note ordine" multiline rows={8} value={this.state.notes} onChange={this.onNotesChange} variant="outlined" />
                    </Grid>

                    {/* --- Riepilogo ordine */}
                    <Grid md={6}>
                        <Paper style={{ boxShadow: '3px 8px 15px 0.1px #ECECEC', borderRadius: "10px", border: "1px solid lightGrey" }}>
                            <Table style={{ marginBottom: "2%" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><Typography variant="h5"><b>Riepilogo ordine</b></Typography></TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.cart.items.map((cartItem, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell>
                                                {cartItem.product.name} x {cartItem.quantity}<br />
                                                {cartItem.product.vatRate !== EVatRate.Rv17 ? "IVA: " + euroPrint(cartItem.taxTotal) + " " : ""}
                                                {cartItem.product.taxSIAE !== 0 ? "SIAE: " + euroPrint(cartItem.product.taxSIAE * cartItem.quantity) : " "}
                                                {cartItem.product.configurable && <div><Button style={{ margin: 0, padding: 0 }} onClick={() => this.setShowEditConfigurationProductDialog(cartItem)}>Configurazione</Button></div>}
                                            </TableCell>
                                            <TableCell>{euroPrint(this.calculateProductTotal(cartItem))}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell>Spedizione</TableCell>
                                        <TableCell>{euroPrint(this.state.cart.shippingTotal)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Totale IVA</TableCell>
                                        <TableCell>{euroPrint(this.state.cart.taxTotal)}</TableCell>
                                    </TableRow>
                                </TableBody>
                                <TableBody>
                                    <TableRow>
                                        <TableCell><Typography variant="h6"><b>Totale</b></Typography></TableCell>
                                        <TableCell><Typography variant="h5" style={{ whiteSpace: "nowrap" }}><b>{euroPrint(this.state.cart.total)}</b></Typography></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            <div style={{ display: 'flex', justifyContent: 'center', padding: "2%" }}>
                                <div style={{ height: '60%', width: '60%' }}>
                                    <PayOrderBtn onPress={this.onPayPressed} loading={this.state.paymentLoading} disabled={this.state.selectedShippingAddressId === ""} />
                                </div>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>

                {/* --- Dialog configuratore */}
                <Dialog open={this.state.showEditConfiguration} onClose={() => this.setShowEditConfigurationProductDialog()}>
                    <DialogTitle>{"Opzioni Selezionate"}</DialogTitle>
                    <DialogContent>
                        <div className="configurator" hidden={this.state.selectedCartItem.addons.length <= 0}>
                            <Divider variant="middle" />
                            <TableContainer style={{ width: '100%' }} component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Nome</TableCell>
                                            <TableCell>Opzione</TableCell>
                                            <TableCell>Quantità</TableCell>
                                            <TableCell>Prezzo</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.selectedCartItem.addons.map((addon, idx) => (
                                            <TableRow key={idx}>
                                                <TableCell>{addon.addonName}</TableCell>
                                                <TableCell>{addon.selectedOptionName}</TableCell>
                                                <TableCell>{addon.selectedQuantity}</TableCell>
                                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                    {euroPrint(addon.selectedOptionPrice !== undefined ? addon.selectedOptionPrice * addon.selectedQuantity : addon.selectedOption?.price ?? 0)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button color={'primary'} onClick={() => this.setShowEditConfigurationProductDialog()}>Chiudi</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

// --- Wrapper per React Router v6
export default function CheckoutWrapper(props: any) {
    const navigate = useNavigate();
    return <Checkout {...props} navigate={navigate} />;
}
